import { useState, useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomTabBar from './BottomTabBar.js';
import getAPI from '../functions/API/getAPI.js';

export default function TenantLayout() {
    const [unreadCount, setUnreadCount] = useState(0);
    const [agreementId, setAgreementId] = useState(null);
    const [agreementAddress, setAgreementAddress] = useState('');
    const [layoutLoading, setLayoutLoading] = useState(true);
    const location = useLocation();

    const fetchLayoutData = useCallback(async () => {
        try {
            const [userRes, agRes, taskMsgRes] = await Promise.all([
                getAPI('userdetails/summary'),
                getAPI('agreements'),
                getAPI('taskmessages/unreadcount'),
            ]);

            let total = 0;
            if (userRes.response?.ok) {
                total += userRes.data?.unread_messages || 0;
            }
            if (taskMsgRes.response?.ok && taskMsgRes.data?.unread_count) {
                total += taskMsgRes.data.unread_count;
            }
            setUnreadCount(total);

            if (agRes.response?.ok && agRes.data?.length > 0) {
                const ref = localStorage.getItem('agreement');
                if (ref) {
                    const match = agRes.data.find(a => a.reference === ref);
                    if (match) {
                        setAgreementId(match.id);
                        setAgreementAddress(match.address || '');
                    } else {
                        setAgreementId(agRes.data[0].id);
                        setAgreementAddress(agRes.data[0].address || '');
                    }
                } else {
                    setAgreementId(agRes.data[0].id);
                    setAgreementAddress(agRes.data[0].address || '');
                }
            }
        } catch (e) {
            // silently fail — nav will still render without badge/doc link
        } finally {
            setLayoutLoading(false);
        }
    }, []);

    // Re-fetch when navigating so agreementId stays in sync after switching
    useEffect(() => {
        fetchLayoutData();
    }, [location.pathname]);

    return (
        <>
            <Outlet context={{ unreadCount, agreementId, agreementAddress, layoutLoading }} />
            <BottomTabBar unreadCount={unreadCount} agreementId={agreementId} />
        </>
    );
}
